import 'css-chunksrc/client/scenes/timeRecordsListingConfiguration/form/columns/styles.scss';export default {
  "columns": "_columns_pylq9_1",
  "columnWrapper": "_columnWrapper_pylq9_7",
  "column": "_column_pylq9_1",
  "iconBox": "_iconBox_pylq9_27",
  "icon": "_icon_pylq9_27",
  "columnIcon": "_columnIcon_pylq9_45",
  "hidden": "_hidden_pylq9_54"
};